import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import Base from './Base'
import moment from 'moment-jalaali';
export class Header extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: props.data,
             taskAlerts: null,    
            showNotifications: false,
            clockedIn: false,
            clockedOut: false,
            clockInTime: null
        }
    }
    componentDidMount() {
        this.httpPost('api/v1/task/alerts', {})
            .then(res => {
                if (res.status === 1) {
                    const total = (res.overdueTaskCount || 0)
                        + (res.totalUnpaidInstallments || 0)
                        + (res.supervisorReviewTasks?.length || 0);
                    this.setState({ taskAlerts: res, totalAlerts: total });
                }
            });
        this.checkAttendance();
    }
    checkAttendance() {
        this.httpPost('api/v1/attendance/todayStatus', {})
            .then(res => {
                if (res.status === 1) {
                    this.setState({
                        clockedIn: res.clockedIn,
                        clockedOut: res.clockedOut,
                        clockInTime: res.clockInTime ? new Date(res.clockInTime) : null
                    });
                }
            });
    }
    toggleNotifications() {
        this.setState({ showNotifications: !this.state.showNotifications });
    }
    toggleSideBar() {

        if (document.getElementById('sideBarMenu').classList.contains("nk-sidebar-active"))
            document.getElementById('sideBarMenu').classList.remove('nk-sidebar-active');
        else
            document.getElementById('sideBarMenu').classList.add('nk-sidebar-active');
    }
    clockOut = () => {
        if (window.confirm('آیا می‌خواهید کار امروز را پایان دهید و خروج بزنید؟')) {
            this.httpPost('api/v1/attendance/clockOut', {})
                .then(data => {
                    if (data.status === 1) {
                        this.showSuccessMessage('خروج با موفقیت ثبت شد');
                        this.setState({ clockedOut: true });
                    } else {
                        this.showErorrMessage(data.message);
                    }
                });
        }
    };
    render() {
        const { data, taskAlerts, showNotifications } = this.state;


        const totalAlerts = taskAlerts ? taskAlerts.overdueTaskCount : 0;
        return <div className="nk-header nk-header-fixed is-light">
            <div className="container-fluid">
                <div className="nk-header-wrap">
                    <div className="nk-menu-trigger d-xl-none ms-n1">
                        <a href="#" onClick={e => this.toggleSideBar()} className="nk-nav-toggle nk-quick-nav-icon" data-target="sidebarMenu"><em className="icon ni ni-menu"></em></a>
                    </div>
                    <div className="nk-header-brand d-xl-none">
                        <a href="/" className="logo-link">
                            <img className="logo-light logo-img" src="/assets/images/logo.webp" alt="" />
                            <img className="logo-dark logo-img" src="/assets/images/logo-dark.webp" alt="" />
                        </a>
                    </div>

                    <div className="nk-header-tools">
                        <ul className="nk-quick-nav">
                            <li className="dropdown user-dropdown">
                                <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
                                    <div className="user-toggle">
                                        <div className="user-avatar sm">
                                            <em className="icon ni ni-user-alt"></em>
                                        </div>
                                        <div className="user-info d-none d-md-block">
                                            <div className="user-status">{this.state.data.global.user.mobile}</div>
                                            <div className="user-name dropdown-indicator">{this.state.data.global.user.fname} {this.state.data.global.user.lname}</div>
                                        </div>
                                    </div>
                                </a>
                                <div className="dropdown-menu dropdown-menu-md dropdown-menu-end dropdown-menu-s1">
                                    <div className="dropdown-inner user-card-wrap bg-lighter d-none d-md-block">
                                        <div className="user-card">
                                            <div className="user-avatar">
                                                <span>{this.state.data.global.user.fname.substring(0, 2)}</span>
                                            </div>
                                            <div className="user-info">
                                                <span className="lead-text">{this.state.data.global.user.fname} {this.state.data.global.user.lname}</span>
                                                <span className="sub-text">{this.state.data.global.user.mobile}</span>
                                            </div>
                                        </div>
                                    </div>
 
                                    <div className="dropdown-inner">
                                        <ul className="link-list">
                                            <li><a className="hand" onClick={e => this.logOut()}><em className="icon ni ni-signout"></em><span>خروج</span></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                            {this.state.clockedIn && !this.state.clockedOut && (
                                <li className="d-none d-md-flex align-items-center ms-2">
                                    <span className="badge badge-success ms-1" style={{ fontSize: '0.9rem' }}>
                                        <em className="icon ni ni-clock"></em> ورود: {moment(this.state.clockInTime).format('HH:mm')}
                                    </span>
                                    <button className="btn btn-sm btn-warning ms-2" onClick={this.clockOut}>
                                        خروج
                                    </button>
                                </li>
                            )}
                            {this.state.clockedOut && (
                                <li className="d-none d-md-flex align-items-center ms-2">
                                    <span className="badge badge-light ms-1">پایان کار امروز</span>
                                </li>
                            )}
                            {this.state.clockedOut && (
                                <li className="d-none d-md-flex align-items-center ms-2">
                                    <span className="badge badge-light ms-1">کار امروز پایان یافت</span>
                                </li>
                            )}
                            <li className="dropdown notification-dropdown me-n1">
                                <a href="#" className="dropdown-toggle nk-quick-nav-icon" data-bs-toggle="dropdown">
                                    <div className="icon-status icon-status-info">
                                        <em className="icon ni ni-bell"></em>
                                        {totalAlerts > 0 && <span className="badge badge-pill badge-danger">{totalAlerts + taskAlerts.totalUnpaidInstallments}</span>}
                                    </div>
                                </a>
                                <div className="dropdown-menu dropdown-menu-xl dropdown-menu-end dropdown-menu-s1">
                                    <div className="dropdown-head">
                                        <span className="sub-title nk-dropdown-title">هشدارها</span>
                                    </div>
                                    <div className="dropdown-body">
                                        <div className="nk-notification">
                               
                                            {taskAlerts && taskAlerts.overdueTasks && taskAlerts.overdueTasks.length > 0 && (
                                                <>
                                                    <div className="dropdown-inner">
                                                        <h6 className="title overline-title">وظایف عقب‌افتاده</h6>
                                                    </div>
                                                    {taskAlerts.overdueTasks.map(task => (
                                                        <div className="nk-notification-item dropdown-inner" key={task.id}>
                                                            <div className="nk-notification-icon">
                                                                <em className="icon icon-circle bg-danger-dim ni ni-alert-fill"></em>
                                                            </div>
                                                            <div className="nk-notification-content">
                                                                <div className="nk-notification-text">{task.title}</div>
                                                                <div className="nk-notification-time">{task.dueDatePersian}</div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </>
                                            )}

                                  
                                            {taskAlerts && taskAlerts.supervisorReviewTasks && taskAlerts.supervisorReviewTasks.length > 0 && (
                                                <>
                                                    <div className="dropdown-inner">
                                                        <h6 className="title overline-title">نیازمند بررسی شما (سرپرست)</h6>
                                                    </div>
                                                    {taskAlerts.supervisorReviewTasks.map(task => (
                                                        <div className="nk-notification-item dropdown-inner" key={task.id}>
                                                            <div className="nk-notification-icon">
                                                                <em className="icon icon-circle bg-info-dim ni ni-check-circle"></em>
                                                            </div>
                                                            <div className="nk-notification-content">
                                                                <div className="nk-notification-text">{task.title}</div>
                                                                <div className="nk-notification-time">{task.dueDatePersian}</div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </>
                                            )}

                                            {taskAlerts && taskAlerts.overduePayments && taskAlerts.overduePayments.length > 0 && (
                                                <>
                                                    <div className="dropdown-inner">
                                                        <h6 className="title overline-title">سررسید اقساط</h6>
                                                    </div>
                                                    {taskAlerts.overduePayments.map(payment => (
                                                        <div className="nk-notification-item dropdown-inner" key={payment.paymentId}>
                                                            <div className="nk-notification-icon">
                                                                <em className="icon icon-circle bg-warning-dim ni ni-coin"></em>
                                                            </div>
                                                            <div className="nk-notification-content">
                                                                <div className="nk-notification-text">{payment.customerName}</div>
                                                                <div className="nk-notification-time">
                                                                    {this.money(payment.amount)} تومان – {payment.paymentDatePersian}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </>
                                            )}

                                            {(!taskAlerts ||
                                                (taskAlerts.overdueTasks?.length === 0 &&
                                                    taskAlerts.supervisorReviewTasks?.length === 0 &&
                                                    taskAlerts.overduePayments?.length === 0)) && (
                                                    <div className="nk-notification-item dropdown-inner">
                                                        <div className="nk-notification-content">
                                                            <span className="text-muted">هیچ هشداری ندارید.</span>
                                                        </div>
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                    <div className="dropdown-foot center">
                                        <NavLink to="/tasks/" className="btn btn-sm btn-primary">مشاهده همه وظایف</NavLink>
                                        <NavLink to="/contracts/" className="btn btn-sm btn-outline-light ms-2">مشاهده قراردادها</NavLink>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    }
}
